module.exports = __webpack_public_path__ + "img/energy_label_blue.d0117188.svg";